import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const links = [
  { label: "Work", href: "#work" },
  { label: "Manifesto", href: "#manifesto" },
  { label: "Case Studies", href: "#case-studies" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <motion.header
        initial={{ y: -40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.9, delay: 1.6, ease: [0.22, 1, 0.36, 1] }}
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled ? "backdrop-blur-md bg-[rgba(10,10,11,0.55)] border-b border-white/5" : ""
        }`}
        data-testid="site-nav"
      >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 py-5 flex items-center justify-between">
          <a
            href="#top"
            className="flex items-center gap-3 group"
            data-testid="nav-logo"
          >
            <span className="inline-block w-2 h-2 rounded-full bg-[var(--copper)] group-hover:scale-125 transition-transform" />
            <span className="font-mono font-bold text-[12px] tracking-[0.24em] uppercase text-[var(--bone)]">
              PREETI BASU
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-9">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="font-mono text-[11px] tracking-[0.2em] uppercase text-[var(--bone-dim)] hover:text-[var(--bone)] link-line"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <button
            onClick={() => setOpen(!open)}
            className="md:hidden flex flex-col gap-1.5 p-2"
            data-testid="nav-toggle"
            aria-label="menu"
          >
            <span className={`block h-[1px] w-6 bg-[var(--bone)] transition-transform ${open ? "translate-y-[6px] rotate-45" : ""}`} />
            <span className={`block h-[1px] w-6 bg-[var(--bone)] transition-opacity ${open ? "opacity-0" : ""}`} />
            <span className={`block h-[1px] w-6 bg-[var(--bone)] transition-transform ${open ? "-translate-y-[6px] -rotate-45" : ""}`} />
          </button>
        </div>
      </motion.header>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-40 md:hidden bg-[var(--ink)] pt-24 px-8"
            data-testid="mobile-menu"
          >
            <div className="flex flex-col gap-6">
              {links.map((l, i) => (
                <motion.a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.05 * i }}
                  className="font-serif italic text-4xl text-[var(--bone)]"
                  data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                >
                  {l.label}
                </motion.a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Nav;
